module.exports = __webpack_public_path__ + "static/img/16.7dfba93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/16.png
// module id = Txx+
// module chunks = 0